import CloseIcon from "@/assets/icons/close.svg?react";
import NoImage from "@/assets/images/no_image.svg";
import { Data } from "@/hooks/useCustomToast";
import { cn } from "@/lib/tailwind";
import { lufga } from "@/utils/fonts";
import Image from "next/image";
import { ToastContentProps } from "react-toastify";
import CldImage from "../ui/cldImg/CldImage";
import { CLink } from "./customLink/CustomLink";
import { getCloudinaryURL } from "@/utils/cloudinary";
import RenderCurrencyInText from "./RenderCurrencyInText";

export const CustomToast = ({ data, closeToast }: ToastContentProps<Data>) => {
  const shouldShowMedia = !data?.hideImage && (data?.icon || data?.imageSrc || data?.imgUrl);
  const mediaWrapperClass = data?.imageSrc
    ? "aspect-square h-10 w-10"
    : "aspect-square h-10 w-10 border-[1px] border-primary-3 bg-white";

  const Content = (
    <div className="flex items-center gap-3">
      {data?.hideImage ? (
        <div className="h-8" />
      ) : shouldShowMedia && data?.icon ? (
        <div className={cn("aspect-square h-10 w-10")}>
          <Image
            className={cn("h-10 w-10 object-contain p-1")}
            src={data?.icon?.src}
            alt={"toast-icon"}
            width={40}
            height={40}
          />
        </div>
      ) : shouldShowMedia ? (
        <div className={cn(mediaWrapperClass)}>
          {data?.imageSrc ? (
            <Image
              src={data.imageSrc}
              width={40}
              height={40}
              alt={"toast-image"}
              className={cn("h-10 w-10 object-contain")}
            />
          ) : data?.imgUrl ? (
            <CldImage
              src={getCloudinaryURL(data?.imgUrl) ?? NoImage}
              width={40}
              height={40}
              alt={"toast-image"}
              className={cn("h-10 w-10 object-contain pb-2")}
              priority
            />
          ) : (
            <Image
              src={NoImage}
              width={40}
              height={40}
              alt={"toast-image"}
              className={cn("h-10 w-10 object-contain pb-2")}
            />
          )}

          {/* <Image
        className={cn("h-10 w-10 object-contain", data?.imgUrl ? "pb-2" : "p-1")}
        src={getCloudinaryURL(data?.imgUrl) ?? NoImageSrc}
        alt={"toast-icon"}
        width={40}
        height={40}
        priority
      /> */}
        </div>
      ) : null}

      {data?.text && (
        typeof data.text === "string" ? (
          <RenderCurrencyInText
            text={data.text}
            className="text-[0.813rem] leading-4 text-black"
            iconClassName="mx-[1px] inline-block -translate-y-[0.07em]"
          />
        ) : (
          <div className="text-[0.813rem] leading-4 text-black">
            {data.text}
          </div>
        )
      )}
    </div>
  );

  return (
    <div
      className={cn(
        "flex w-[304px] items-center justify-between px-3 py-[10px]",
        data?.lang === "en" ? lufga?.className : "font-sans",
      )}
      style={{ backgroundColor: data?.bgColor ?? "#F1EBE3" }}
    >
      {data?.redirectUrl ? <CLink href={data?.redirectUrl}>{Content}</CLink> : Content}
      <div className="h-4 w-4 cursor-pointer" onClick={closeToast}>
        <CloseIcon height={13} width={13} />
      </div>
    </div>
  );
};
